import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { siteConfig } from "@/lib/data";

export default function PrivacyPolicyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | {siteConfig.name}</title>
        <meta name="description" content="Kebijakan privasi PT. Naincode Inti Technology. Pelajari bagaimana kami mengumpulkan, menggunakan, dan melindungi data pribadi Anda." />
        <link rel="canonical" href={`${siteConfig.url}/privacy-policy`} />
      </Helmet>
      
      <section className="pt-32 pb-24">
      <div className="section-container section-padding">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-neon-400 transition-colors mb-8">
            <ArrowLeft className="w-4 h-4" />
            Kembali
          </Link>

          <h1 className="text-3xl md:text-4xl font-bold gradient-text-white mb-8">
            Privacy Policy
          </h1>

          <div className="prose prose-invert max-w-none">
            <p className="text-white/50 mb-6">
              Terakhir diperbarui: 14 April 2026
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Informasi yang Kami Kumpulkan</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Kami mengumpulkan informasi yang Anda berikan secara sukarela saat mengisi form konsultasi, termasuk nama, email, nomor telepon, nama perusahaan, dan detail project.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Bagaimana Kami Menggunakan Informasi Anda</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Informasi yang dikumpulkan digunakan untuk:
            </p>
            <ul className="list-disc list-inside text-white/50 space-y-2 mb-4">
              <li>Menghubungi Anda terkait permintaan konsultasi</li>
              <li>Memahami kebutuhan project Anda</li>
              <li>Mengirimkan update dan informasi relevan tentang layanan kami</li>
            </ul>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Keamanan Data</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Kami menerapkan langkah-langkah keamanan yang sesuai untuk melindungi informasi pribadi Anda dari akses tidak sah, perubahan, pengungkapan, atau penghancuran.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Berbagi Informasi</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Kami tidak menjual, menyewakan, atau membagikan informasi pribadi Anda kepada pihak ketiga tanpa persetujuan Anda, kecuali diwajibkan oleh hukum.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Hak Anda</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Anda memiliki hak untuk mengakses, memperbaiki, atau menghapus informasi pribadi Anda. Untuk melakukan ini, silakan hubungi kami di hello@naincode.com.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Cookie</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Website kami menggunakan cookie untuk meningkatkan pengalaman pengguna. Cookie adalah file kecil yang disimpan di perangkat Anda saat Anda mengunjungi website.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Hubungi Kami</h2>
            <p className="text-white/50 leading-relaxed mb-4">
              Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, silakan hubungi kami di:
            </p>
            <p className="text-white/50 leading-relaxed">
              <strong>Email:</strong> hello@naincode.com<br />
              <strong>Telepon:</strong> +62 877-8814-1650<br />
              <strong>Alamat:</strong> Jl. Tanah Abang II No.74A, Petojo Sel., Kecamatan Gambir, Kota Jakarta Pusat, DKI Jakarta 10160
            </p>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
